export { default } from './ColumnLabel';
